/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InsuranceCode/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import Empty from './Empty/index'
import Error from './Error/index'
import Loading from './Loading/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function InsuranceCode({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreateClaim/Charges/Charge/Type/Content/AddInsuranceCode/Content/InsuranceCode"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Loading'}>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Error'}>
<Error
  viewPath={`${viewPath}/Error`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Empty'}>
<Empty
  viewPath={`${viewPath}/Empty`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}